import { LayoutModule } from '@angular/cdk/layout';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { SelectModule } from 'src/app/components/select/select.module';
import { environment } from 'src/environments/environment';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptor } from './auth/interceptors/jwt.interceptor';
import { ConfirmationDialogComponent } from './components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { CreateNewPoAccountDialogComponent } from './components/dialogs/create-new-po-account-dialog/create-new-po-account-dialog.component';
import { DateRangePickerDialogComponent } from './components/dialogs/date-range-picker-dialog/date-range-picker-dialog.component';
import { EditPoAccountDialogComponent } from './components/dialogs/edit-po-account-dialog/edit-po-account-dialog.component';
import { InfoDialogComponent } from './components/dialogs/info-dialog/info-dialog.component';
import { PickUsersDialogComponent } from './components/dialogs/pick-users-dialog/pick-users-dialog.component';
import { PickVendorsDialogComponent } from './components/dialogs/pick-vendors-dialog/pick-vendors-dialog.component';
import { PoAccountDetailsDialogComponent } from './components/dialogs/po-account-details-dialog/po-account-details-dialog.component';
import { RecentAgentsComponent } from './components/dialogs/po-account-details-dialog/recent-agents/recent-agents.component';
import { TicketsIngestedComponent } from './components/dialogs/po-account-details-dialog/tickets/tickets-ingested.component';
import { UploadPdfDialogComponent } from './components/dialogs/upload-pdf-dialog/upload-pdf-dialog.component';
import { ItemRenderersModule } from './components/table/item-renderer/item-renderers/item-renderers.module';
import { TableModule } from './components/table/table.module';
import { AddressComponent } from './dialogs/address/address.component';
import { AuditHistoryComponent } from './dialogs/audit-history/audit-history.component';
import { ConfirmEmailComponent } from './dialogs/confirm-email/confirm-email.component';
import { OptimalNotesComponent } from './dialogs/optimal-notes/optimal-notes.component';
import { PasswordComponent } from './dialogs/password/password.component';
import { ProfileComponent } from './dialogs/profile/profile.component';
import { TagsEditingComponent } from './dialogs/tags-editing/tags-editing.component';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { MaterialModule } from './material-module';
import { PipesModule } from './pipes/pipes.module';
import { TablesModule } from './tables/tables.module';

@NgModule({
  declarations: [
    AppComponent,
    ProfileComponent,
    PasswordComponent,
    AuditHistoryComponent,
    OptimalNotesComponent,
    DateRangePickerDialogComponent,
    UploadPdfDialogComponent,
    DateRangePickerDialogComponent,
    ConfirmEmailComponent,
    AddressComponent,
    CreateNewPoAccountDialogComponent,
    TagsEditingComponent,
    EditPoAccountDialogComponent,
    PoAccountDetailsDialogComponent,
    RecentAgentsComponent,
    TicketsIngestedComponent,
    ConfirmationDialogComponent,
    InfoDialogComponent,
    PickVendorsDialogComponent,
    PickUsersDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    BrowserAnimationsModule,
    MaterialModule,
    ItemRenderersModule,
    TableModule,
    TablesModule,
    PipesModule,
    SelectModule,
    LayoutModule,
    AuthModule.forRoot({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      useRefreshTokens: true,
      authorizationParams: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        redirect_uri: environment.auth0.redirectUri ?? window.location.origin,
        audience: 'http://optimalticketing.com',
        scope: 'openid profile email',
      },
      httpInterceptor: {
        allowedList: [`${environment.apiUrl}*`],
      },
    }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: APP_BASE_HREF,
      useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
      deps: [PlatformLocation],
    },
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: 'primary' },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
